// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CountriesRouteImport } from './routes/countries'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as VideosRouteImport } from './routes/videos'
import { Route as YoutubersRouteImport } from './routes/youtubers'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as CountryCodeRouteImport } from './routes/country.$code'
import { Route as VSlugRouteImport } from './routes/v.$slug'
import { Route as YHandleRouteImport } from './routes/y.$handle'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin.index'
import { Route as AuthenticatedAdminInboxRouteImport } from './routes/_authenticated/admin.inbox'
import { Route as AuthenticatedAdminMaintenanceRouteImport } from './routes/_authenticated/admin.maintenance'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin.settings'
import { Route as ApiPublicArchiveRouteImport } from './routes/api/public/archive'
import { Route as AuthenticatedAdminCreatorsIndexRouteImport } from './routes/_authenticated/admin.creators.index'
import { Route as AuthenticatedAdminCreatorsIdRouteImport } from './routes/_authenticated/admin.creators.$id'
import { Route as AuthenticatedAdminVideosIdRouteImport } from './routes/_authenticated/admin.videos.$id'
import { Route as AuthenticatedAdminYoutubersIdRouteImport } from './routes/_authenticated/admin.youtubers.$id'
import { Route as ApiPublicHooksRefreshViewsRouteImport } from './routes/api/public/hooks/refresh-views'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CountriesRoute = CountriesRouteImport.update({
            id: '/countries',path: '/countries',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const VideosRoute = VideosRouteImport.update({
            id: '/videos',path: '/videos',getParentRoute: () => rootRouteImport
          })
const YoutubersRoute = YoutubersRouteImport.update({
            id: '/youtubers',path: '/youtubers',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const CountryCodeRoute = CountryCodeRouteImport.update({
            id: '/country/$code',path: '/country/$code',getParentRoute: () => rootRouteImport
          })
const VSlugRoute = VSlugRouteImport.update({
            id: '/v/$slug',path: '/v/$slug',getParentRoute: () => rootRouteImport
          })
const YHandleRoute = YHandleRouteImport.update({
            id: '/y/$handle',path: '/y/$handle',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminInboxRoute = AuthenticatedAdminInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminMaintenanceRoute = AuthenticatedAdminMaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const ApiPublicArchiveRoute = ApiPublicArchiveRouteImport.update({
            id: '/api/public/archive',path: '/api/public/archive',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminCreatorsIndexRoute = AuthenticatedAdminCreatorsIndexRouteImport.update({
            id: '/creators/',path: '/creators/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCreatorsIdRoute = AuthenticatedAdminCreatorsIdRouteImport.update({
            id: '/creators/$id',path: '/creators/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminVideosIdRoute = AuthenticatedAdminVideosIdRouteImport.update({
            id: '/videos/$id',path: '/videos/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminYoutubersIdRoute = AuthenticatedAdminYoutubersIdRouteImport.update({
            id: '/youtubers/$id',path: '/youtubers/$id',getParentRoute: () => AuthenticatedAdminRoute
          })
const ApiPublicHooksRefreshViewsRoute = ApiPublicHooksRefreshViewsRouteImport.update({
            id: '/api/public/hooks/refresh-views',path: '/api/public/hooks/refresh-views',getParentRoute: () => rootRouteImport
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminInboxRoute: AuthenticatedAdminInboxRoute,AuthenticatedAdminMaintenanceRoute: AuthenticatedAdminMaintenanceRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,AuthenticatedAdminCreatorsIdRoute: AuthenticatedAdminCreatorsIdRoute,AuthenticatedAdminVideosIdRoute: AuthenticatedAdminVideosIdRoute,AuthenticatedAdminYoutubersIdRoute: AuthenticatedAdminYoutubersIdRoute,AuthenticatedAdminCreatorsIndexRoute: AuthenticatedAdminCreatorsIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,CountriesRoute: CountriesRoute,SitemapDotxmlRoute: SitemapDotxmlRoute,VideosRoute: VideosRoute,YoutubersRoute: YoutubersRoute,CountryCodeRoute: CountryCodeRoute,VSlugRoute: VSlugRoute,YHandleRoute: YHandleRoute,ApiPublicArchiveRoute: ApiPublicArchiveRoute,ApiPublicHooksRefreshViewsRoute: ApiPublicHooksRefreshViewsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)